import { useEffect, useState } from 'react';
import { Practice } from 'src/pages/accueil/model/types';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export const usePractices = () => {
  const httpClient = useHttpClient();
  const [practices, setPractices] = useState<Practice[]>([]);

  useEffect(() => {
    const fetch = async () => {
      const response = await httpClient.current?.get(`/api/practices`);
      setPractices(response.data);
    };
    fetch();
  }, [httpClient]);

  return { practices, setPractices };
};
